import { ChevronDown, Star } from "lucide-react"
import { useTranslation } from "react-i18next"

import { Button } from "@f2e/ui/components/base"

import { AgentHistory } from "@/types"
import { AgentHistoryDropdownState } from "@/hooks/useAgentHistories"

import { AgentHistoryDropdownBase } from "@/components/Agent/AgentHistoryDropdownBase"
import { AgentHistoryDetailedItem } from "@/components/Agent/AgentHistoryDetailedItem"

interface AgentHistoryDropdownProps {
  agentId: string
  disabled?: boolean
  state: AgentHistoryDropdownState
}

export const AgentHistoryDropdown = ({
  agentId,
  disabled = false,
  state,
}: AgentHistoryDropdownProps) => {
  const { t } = useTranslation()

  const renderDetailedTrigger = (currentHistory: AgentHistory | null) => (
    <Button
      variant="outline"
      size="sm"
      disabled={disabled}
      className="h-8 px-3 gap-2"
    >
      <span className="text-sm font-medium">
        {disabled
          ? t("workspace.agent.history.ui.noVersionsAvailable")
          : currentHistory
            ? t("workspace.agent.history.ui.versionNumber", {
                number: currentHistory.versionNumber,
              })
            : t("workspace.new")}
      </span>
      {currentHistory?.wasPublished && (
        <Star className="h-3 w-3 text-yellow-500 fill-current" />
      )}
      <ChevronDown className="h-3 w-3" />
    </Button>
  )

  return (
    <AgentHistoryDropdownBase
      agentId={agentId}
      state={state}
      disabled={disabled}
      renderItem={(history, isCurrent) => (
        <AgentHistoryDetailedItem history={history} isCurrent={isCurrent} />
      )}
      renderTrigger={renderDetailedTrigger}
      showPagination={true}
    />
  )
}
